import React, { useState, useRef, useContext } from "react";
import { ShoppingCart } from "../App";
import useScreenSize from "./hooks/useScreenSize";
import ProductInCart from "./ProductInCart";
import { Link } from "react-router-dom";
import { BiRightArrow } from "react-icons/bi";

const Checkout = () => {
  const { isLargeScreen } = useScreenSize();
  const { cart, setCart } = useContext(ShoppingCart);
  const checkoutButton = useRef(null);
  const askAddress = useRef(null);
  const askEmail = useRef(null);

  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");

  const items = [];

  const isEqual = (a, b) =>
    a.name === b.name && a.category === b.category && a.content === b.content;

  cart.forEach((product) => {
    let index = -1;
    for (let i = 0; i < items.length; i++) {
      if (isEqual(items[i].product, product)) {
        index = i;
        break;
      }
    }
    if (index !== -1) {
      items[index].quantity++;
    } else {
      items.push({
        product,
        quantity: 1,
      });
    }
  });
  items.sort((a, b) => a.product.content.localeCompare(b.product.content));

  async function initiatePayment() {
    const delivery = address.length !== 0;
    const checkoutItems = items.map((item) => {
      return { price: item.product.priceID, quantity: item.quantity };
    });
    try {
      const res = await fetch(
        "https://customcalligraphyapi.azurewebsites.net/create-checkout-session",
        {
          method: "POST",
          body: JSON.stringify({
            items: checkoutItems,
            delivery,
            address,
            email,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      const resData = await res.json();
      checkoutButton.current.classList.remove("loading");

      window.open(resData.sessionURL);
      return false;
    } catch (err) {
      console.log(err);
    }
  }

  const checkoutItems = async (e) => {
    e.preventDefault();

    console.log("checking out", items);
    let needAddress = false;
    items.forEach((item) => {
      if (item.product.category === "physical") {
        console.log("asking ");
        needAddress = true;
      }
    });

    if (needAddress) {
      askAddress.current.checked = needAddress;
    } else {
      askEmail.current.checked = true;
    }
  };

  const getResponsiveTooltipClasses = () =>
    isLargeScreen() ? " " : " tooltip-open";

  const getStatus = (check) =>
    check.length === 0 ? "btn-disabled" : "btn-active btn-primary";

  return (
    <div className="section-padding flex flex-col pb-56">
      <h1 className="section-heading">Cart</h1>
      <div className="grid grid-cols-1 gap-4 w-full h-max overflow-x-hidden overflow-y-hidden px-2 sm:px-4 md:px-6">
        <div className="fixed w-full h-[95%] bg-primary left-0 transform -rotate-6 scale-x-150 "></div>
        {items.length === 0 && (
          <div className="w-max relative m-auto text-center mt-12">
            <p className="section-desc mb-2 text-center text-base-300">
              No Items In Cart
            </p>
            <Link
              to="/products"
              className="btn btn-outline text-base-100 border-base-100 hover:bg-base-100 hover:text-primary"
            >
              View Products
            </Link>
          </div>
        )}
        {items.map((item, i) => (
          <ProductInCart
            key={i}
            {...item.product}
            quantity={item.quantity}
            decreaseQuantity={() => {
              setCart((cart) => {
                let index = 0;
                for (let j = 0; j < cart.length; j++) {
                  if (isEqual(cart[j], items[i].product)) {
                    index = j;
                    break;
                  }
                }
                const newCart = [
                  ...cart.slice(0, index),
                  ...cart.slice(index + 1),
                ];
                console.log("decreasing", newCart, cart);
                return newCart;
              });
            }}
            increaseQuantity={() =>
              setCart((cart) => {
                return [...cart, items[i].product];
              })
            }
          />
        ))}
      </div>
      <section className="md:flex section-padding bg-base-100 fixed bottom-0 pb-4 md:py-0 md:h-max md:py-4 w-full border-t border-primary z-50 left-0">
        <div className="flex-1 md:flex md:place-items-center">
          <p className="section-desc text-center lg:text-left pb-0 mt-5 md:my-0">
            <strong>Subtotal</strong>: $
            {cart.reduce((last, current) => last + current.price, 0)} USD
          </p>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            checkoutItems(e);
            return false;
          }}
          className="bg-base-100 w-max relative m-auto pb-8 -mt-3 md:p-0 md:m-0 md:h-full md:flex md:place-items-center md:pb-8 lg:py-4 lg:mt-0"
        >
          <div
            className={
              "tooltip tooltip-bottom lg:tooltip-left px-2" +
              getResponsiveTooltipClasses()
            }
            data-tip={
              items.length === 0
                ? "Please add an item to the cart to checkout"
                : "We use Stripe to process your payment. "
            }
          >
            <button
              className={
                getStatus(items) + " btn btn-wide text-white relative m-auto"
              }
              onClick={(e) => e.target.classList.add("loading")}
              ref={checkoutButton}
              type="submit"
            >
              Checkout {cart.length} Items
            </button>
          </div>
        </form>
      </section>

      {/* Put this part before </body> tag */}
      <input
        ref={askAddress}
        type="checkbox"
        id="address"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="address"
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={() => checkoutButton.current.classList.remove("loading")}
          >
            ✕
          </label>
          <h3 className="text-lg font-bold">Where should we deliver?</h3>
          <p className="py-4">
            We only ship within the United States. If you enter an international
            address we will have to send you a digital copy.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              askAddress.current.checked = false;
              askEmail.current.checked = true;
            }}
            className="flex gap-2 sm:gap-4"
          >
            <input
              type="address"
              className="input w-full input-primary"
              placeholder="Delivery Address"
              onChange={(e) => setAddress(e.target.value)}
            ></input>

            <button className={"btn flex gap-2 " + getStatus(address)}>
              Next <BiRightArrow />
            </button>
          </form>
        </div>
      </div>
      <input
        ref={askEmail}
        type="checkbox"
        id="email"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="email"
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={() => checkoutButton.current.classList.remove("loading")}
          >
            ✕
          </label>
          <h3 className="text-lg font-bold">
            Would you like to receive updates/promotions?
          </h3>
          <p className="py-4">
            If you share your email we will periodically update you on the
            status of your order and new promotions.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              askEmail.current.checked = false;
              initiatePayment();
            }}
            className="flex gap-2 sm:gap-4"
          >
            <input
              type="email"
              className="input w-full input-primary"
              placeholder="Email Address"
              onChange={(e) => setEmail(e.target.value)}
            ></input>

            <button type="submit" className={"btn flex gap-2"}>
              Payment <BiRightArrow />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
